// feedback.service.ts
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

export type FeedbackExtra = {
  module?: string;
  subject?: string;
  category?: string;
  entrySlug?: string;
  emailRaw?: string;
  charCount?: number;
  wordCount?: number;
  typingMs?: number;
  dwellMs?: number;
};

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  async send(
    message: string,
    extra: Partial<FeedbackExtra> = {}
  ): Promise<void> {
    const payload = {
      message: String(message ?? '').trim(),
      url: typeof location !== 'undefined' ? location.href : null,
      path: typeof location !== 'undefined' ? location.pathname : null,
      ts: Date.now(),
      lang: typeof navigator !== 'undefined' ? navigator.language : null,
      tzOffsetMin: new Date().getTimezoneOffset(),
      viewport:
        typeof window !== 'undefined'
          ? {
              w: window.innerWidth,
              h: window.innerHeight,
              dpr: window.devicePixelRatio || 1,
            }
          : null,
      ...extra,
    };

    if (!payload.message) return;

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    try {
      const res = await fetch(environment.feedbackUrl, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers,
        keepalive: true,
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        let detail = '';
        try {
          detail = JSON.stringify(await res.json());
        } catch {
          try {
            detail = await res.text();
          } catch {}
        }
        throw new Error(
          `Feedback failed: ${res.status} ${res.statusText} ${detail}`
        );
      }
    } catch (e: any) {
      throw new Error(`Feedback network error: ${e?.message || e}`);
    }
  }
}
